import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as My2NAppAccessDisabled } from '../../assets/my2n-app-access-disabled.svg';

function My2NAppAccessDisabledIcon({ ...props }: SvgIconProps) {
  return <SvgIcon component={My2NAppAccessDisabled} {...props} />;
}

export default My2NAppAccessDisabledIcon;
